import React from 'react'
import PowerOfficialsBreadCrumb from './PowerOfficialsBreadCrumb';
import PowerOfficials from './PowerOfficials';
function PowerOfficialPage() {
    return ( 
        <div className="container-fluid">
            <PowerOfficialsBreadCrumb />
            <PowerOfficials />
        </div>
     );
}

export default PowerOfficialPage;